(function () {
  'use strict';

  angular.module('sempraWebapp').factory('errorActions', errorActionsFactory);

  /** @ngInject */
  function errorActionsFactory (dispatcher, ActionTypesEnum, $state) {
    return {
      showErrorPage : showErrorPage,
      acknowledgeAndGoBack : acknowledgeAndGoBack,
      showErrorMsg : showErrorMsg,
      acknowledgeErrorMsg : acknowledgeErrorMsg,
      showErrorPageReturnToDashboard: showErrorPageReturnToDashboard
    };


    function showErrorPage (payload) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_ERROR_PAGE,
            payload: payload
        });
        $state.go('app.errorPage');
    }

    function showErrorPageReturnToDashboard (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_ERROR_PAGE,
        payload: payload
      });
      $state.go('app.errorPageWithRedirectToDashboard');
    }

    function acknowledgeAndGoBack(){
        dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_ERROR_PAGE,
            payload: true
        });
      history.go(-2);
    }

    function showErrorMsg(payload){
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_ERROR_MSG,
            payload: payload
        });
    }

    function acknowledgeErrorMsg(){
        dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_ERROR_MSG,
            payload: true
        });
    }

  }
})();
